export const FETCH_HEARTED_PICS = "FETCH_HEARTED_PICS";
export const FETCH_HEARTED_PICS_SUCCESS = "FETCH_HEARTED_PICS_SUCCESS";
export const FETCH_HEARTED_PICS_ERROR = "FETCH_HEARTED_PICS_ERROR";

export const HEART_PIC = "HEART_PIC";
export const HEART_PIC_SUCCESS = "HEART_PIC_SUCCESS";
export const HEART_PIC_ERROR = "HEART_PIC_ERROR";

export const UNHEART_PIC = "UNHEART_PIC";
export const UNHEART_PIC_SUCCESS = "UNHEART_PIC_SUCCESS";
export const UNHEART_PIC_ERROR = "UNHEART_PIC_ERROR";

/**
 * Action to get the users hearted pics
 */
export function fetchHeartedPics() {
    return {
        type: FETCH_HEARTED_PICS
    };
}

/**
 * Hearted Pics successfully fetched
 * @param pics
 * @returns {{type: string, payload: {pics: *}}}
 */
export function fetchHeartedPicsSuccess(pics) {
    return {
        type: FETCH_HEARTED_PICS_SUCCESS,
        payload: pics
    };
}

/**
 * Hearted Pics failed to fetch
 * @param error
 * @returns {{type: string, payload: {error: *}}}
 */
export function fetchHeartedPicsError(error) {
    return {
        type: FETCH_HEARTED_PICS_ERROR,
        payload: {
            error: error
        }
    };
}

/**
 * User hearts a particular picture
 * @param id Id of the Engage pic
 */
export function heartPic(id, component = {}) {
    return {
        type: HEART_PIC,
        meta: {
            component: component
        },
        payload: {
            id: id
        }
    };
}

/**
 * Heart Pic successful
 */
export function heartPicSuccess(id, component = {}) {
    return {
        type: HEART_PIC_SUCCESS,
        meta: {
            component: component
        },
        payload: {
            id: id
        }
    };
}

/**
 * Heart Pic failed to heart
 */
export function heartPicError(error) {
    return {
        type: HEART_PIC_ERROR,
        payload: {
            error: error
        }
    };
}

/**
 * User unhearts a particular picture
 * @param id Id of the Engage pic
 */
export function unheartPic(id, component = {}) {
    return {
        type: UNHEART_PIC,
        meta: {
            component: component
        },
        payload: {
            id: id
        }
    };
}

/**
 * Unheart Pic successful
 */
export function unheartPicSuccess(id, component = {}) {
    return {
        type: UNHEART_PIC_SUCCESS,
        meta: {
            component: component
        },
        payload: {
            id: id
        }
    };
}

/**
 * Unheart Pic failed to heart
 */
export function unheartPicError(error) {
    return {
        type: UNHEART_PIC_ERROR,
        payload: {
            error: error
        }
    };
}
